package org.hs_soft.runmynesto.pages.components


import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.BoxSizing
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Resize
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.boxSizing
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onFocusIn
import com.varabyte.kobweb.compose.ui.modifiers.onFocusOut
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.onMouseOver
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.resize
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.browser.document
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.rippleEffect
import org.hs_soft.runmynesto.domain.util.Constants
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.minus
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.plus
import org.jetbrains.compose.web.css.px
import kotlin.js.Date

@Composable
fun OutlinedBox(
    modifier: Modifier=Modifier,
    fillMaxWidth:Boolean=false,
    label:String="",
    isExpanded:Boolean=false,
    height:CSSSizeValue<CSSUnit.px> = Dimen.outlinedEditTextParentHeight,
    width:CSSSizeValue<CSSUnit.px> = Dimen.semiLargeEditTextWidth,
    boxContent:@Composable ()->Unit,
    expandableList:@Composable ()->Unit ={},
    iconPath: String? = null,
    dismissExpandedList:()->Unit={},
    onClick:()->Unit={},
) {
    val isHovered = remember { mutableStateOf(false) }
    val isFocused = remember { mutableStateOf(false) }
    val uniqueId = remember { "outlined-box-${Date.now()}" }

    DisposableEffect(Unit)
    {
        val clickListener: (org.w3c.dom.events.Event) -> Unit = { event ->
            val target = event.target as? org.w3c.dom.Element
            val boxElement = document.getElementById(uniqueId)

            if (isFocused.value && boxElement != null && !boxElement.contains(target)) {
                isFocused.value = false
            }
        }

        document.addEventListener("mousedown", clickListener)

        onDispose {
            document.removeEventListener("mousedown", clickListener)
        }
    }

    if (isExpanded){
        Box(
            modifier = Modifier
                .position(Position.Absolute)
                .top(0.px)
                .left(0.px)
                .right(0.px)
                .bottom(0.px)
                .fillMaxSize()
                .onClick {
                    dismissExpandedList()
                }
        )
    }

    Column(
        modifier=Modifier
            .width(width)
            .thenIf(
                fillMaxWidth,
                Modifier.fillMaxWidth()
            )
    ) {
        Box(
            modifier = modifier
                .cursor(Cursor.Pointer)
                .flexDirection(FlexDirection.Column)
                .position(Position.Relative)
                .onFocusIn { isFocused.value = true }
                .onFocusOut { isFocused.value = false }
                .onClick {
                    onClick()
                    isFocused.value = true
                }
                .onMouseOver { isHovered.value=true }
                .onMouseLeave {isHovered.value=false }
                .zIndex(Constants.ZIndex.mediumZIndex)
                .fillMaxWidth()
                .minHeight(height)
                .attrsModifier {
                    attr("id", uniqueId)
                }
        )
        {
            if (label.isNotEmpty()){
                Box(
                    modifier=Modifier
                        .margin(left = Dimen.mediumPadding)
                )
                {
                    Box(
                        modifier=Modifier
                            .fillMaxWidth()
                            .align(Alignment.Center)
                            .backgroundColor(Theme.White.rgb)
                            .zIndex(Constants.ZIndex.smallZIndex)
                            .height(Dimen.extraLargeThickness)
                    )
                    SpanText(
                        text = label,
                        modifier = Modifier
                            .align(Alignment.Center)
                            .zIndex(Constants.ZIndex.smallZIndex)
                            .align(Alignment.TopStart)
                            .padding(leftRight = Dimen.smallPadding)
                            .fontWeight(FontWeight.Normal)
                            .fontFamily(FontFamily.Jakarta)
                            .color(if (isFocused.value)
                                Theme.PrimaryMain.rgb else Theme.TextSecondary.rgb)
                            .fontSize(FontSizes.semiMediumFontSize)
                    )
                }
            }

            Row(
                modifier = Modifier
                    .height(
                        Dimen.mediumOutlinedEditTextHeight
                    )
                    .fillMaxWidth()
                    .align(Alignment.BottomStart)
                    .padding(
                        leftRight =
                            if (isFocused.value)
                                Dimen.smallPadding.minus(Dimen.smallThickness)
                            else Dimen.smallPadding,
                    )
                    .styleModifier {
                        property("border-width", if (isFocused.value)
                            "${Dimen.mediumThickness.value}px"
                        else
                            "${Dimen.smallThickness.value}px")
                        property("border-style", "solid")
                        property("border-color", when {
                            isFocused.value -> Theme.PrimaryMain.hex
                            isHovered.value -> Theme.TextPrimary.hex
                            else -> Theme.InputEnabledBorder.hex
                        })
                        property("box-sizing", "border-box")
                        property("border-radius", "${Dimen.lowBorderRadius}")
                        property("position", "relative")
                        property("background-color", Theme.White.hex)
                    }
            ) {

                boxContent()

                Spacer()

                if (iconPath != null) {
                    VectorIcon(
                        modifier = Modifier
                            .position(Position.Absolute)
                            .zIndex(Constants.ZIndex.mediumZIndex)
                            .right(Dimen.mediumPadding)
                            .margin(
                                right = if (isFocused.value) (-0.5).px
                                else 0.px
                            )
                            .top(50.percent)
                            .styleModifier {
                                property("transform", "translateY(-50%)")
                                property("pointer-events", "none")
                            },
                        pathData = iconPath,
                        width = Dimen.normalIconSize,
                        height = Dimen.normalIconSize,
                        color = if (isFocused.value) Theme.PrimaryMain.hex
                        else Theme.TextSecondary.hex,
                    )
                }
            }


        }

        if (isExpanded){
            Box(
                modifier = Modifier
                    .top(Dimen.mediumOutlinedEditTextHeight
                        .plus(Dimen.normalPadding)
                    )
                    .margin(top = Dimen.mediumPadding)
                    .fillMaxWidth()
                    .padding(topBottom = Dimen.mediumPadding)
                    .borderRadius(Dimen.lowBorderRadius)
                    .border(
                        width=Dimen.smallThickness,
                        color = Theme.ActionFocused.rgb,
                        style = LineStyle.Solid
                    )
                    .overflow(Overflow.Auto)
                    .backgroundColor(Theme.White.rgb)
                    .zIndex(Constants.ZIndex.largeZIndex)
                    .styleModifier {
                        property("box-shadow", "0px 3px 15px 0px" +
                                " ${Theme.ActionFocused.rgb}")
                    }
            ) {
                expandableList()
            }
        }


    }

}
